export default class Model {
  get estaDeletado() {
    return Boolean(this.deleted_at);
  }
}
